var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketingPromotions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4132 3.47998L8.05322 10.6933",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.93335 15.2133L19.3867 18.7467",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19797 10.625L3.99186 11.2511C3.33418 11.3796 2.90514 12.0169 3.03358 12.6745L3.53958 15.2656C3.66801 15.9233 4.30529 16.3523 4.96297 16.2239L8.16907 15.5978C8.82675 15.4693 9.25579 14.8321 9.12736 14.1744L8.62136 11.5833C8.49292 10.9256 7.85565 10.4966 7.19797 10.625Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.63086 15.7386L3.19902 15.823C2.75409 15.9099 2.33176 15.6255 2.24487 15.1806L1.86154 13.2177C1.77465 12.7728 2.05898 12.3504 2.50391 12.2636L2.93575 12.1792L3.63086 15.7386Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8667 7.39996C20.4267 7.5333 21.7734 8.67996 22.08 10.2933C22.3867 11.9066 21.5867 13.48 20.1867 14.1866",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.34668 16.1467L7.38668 21.44C7.45335 21.6267 7.65335 21.7333 7.84001 21.6933L10.0133 21.2667C10.2667 21.2133 10.4 20.96 10.32 20.72L8.33335 15.56",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3757 2.31245L16.8392 2.41722C16.5718 2.46945 16.3973 2.72856 16.4495 2.99597L19.5571 18.9087C19.6093 19.1761 19.8684 19.3506 20.1358 19.2983L20.6723 19.1936C20.9398 19.1413 21.1142 18.8822 21.062 18.6148L17.9544 2.70208C17.9022 2.43467 17.6431 2.26023 17.3757 2.31245Z",
    stroke: "#F4F4F9",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketingPromotions);
export default __webpack_public_path__ + "static/media/MarketingPromotions.140d5c3137426364c87b421a1286c095.svg";
export { ForwardRef as ReactComponent };